export default class MaillageFormations {
    constructor() {
        this.maillageFormations = document.querySelector('.maillage-formations');
        this.formationList = document.querySelector('#formationList');
    }

    init() {
        if (!this.maillageFormations) return;
        this.getMaillageFormation();
    }

    async getMaillageFormation() {
        const currentProductId = this.maillageFormations.dataset.productId;
        if (!currentProductId) return;

        const formData = new FormData();
        formData.append('action', 'get_products_from_main_site');
        formData.append('current_product_id', currentProductId);

        try {
            const response = await fetch(this.maillageFormations.dataset.ajaxurl, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                this.displayFormations(data.data);
            } else {
                console.error('Erreur :', data.data.message);
            }
        } catch (error) {
            console.error('Erreur AJAX :', error);
        }
    }

    displayFormations(formations) {
        if (!this.formationList) return;

        if (formations.length === 0) {
            this.maillageFormations.remove();
            return;
        }

        this.formationList.innerHTML = formations.map(formation => {
            const thematiques = formation.thematique.map(t => `<span class="thematique">${t}</span>`).join(', ');

            const qualifications = formation.qualification_details.map(q => {

                const color = q.color || '#f0f0f0'; // Correction ici
                const name = q.name || '';
                return `
                    <div class="tag" style="background-color: ${color}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" fill="none">
                            <path fill="#1A1F2F" d="M12 9.75V.25L0 9.75h12Z"></path>
                        </svg> ${name}
                    </div>
                `;
            }).join('');

            return `
                <div class="swiper-slide">
                    <div class="product-item">
                        <div class="card card-formation">
                            <div class="qualif default">
                                ${qualifications}
                            </div>
                            <div class="card-content">
                                <div class="card-content-info">
                                    <div>
                                        <h3 class="title">
                                            <a href="${formation.permalink}" target="_blank">${formation.post_title}</a>
                                        </h3>
                                        <div class="product-thematiques">${thematiques}</div>
                                    </div>
                                    <div>
                                        <a href="${formation.permalink}" target="_blank" class="btn btn-dark">En savoir plus</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        }).join('');
    }
}
